import * as Common from '@/tenant/common';

export class Delivery extends Common.StateObject{
  constructor(){
    super('Delivery')
    this.binders.counterpart = new Common.ModelBinder(Common.Counterpart);
    this.binders.paymentBalance = new Common.ModelBinder(Common.TransferBalance);
    this.binders.bankAccount = new Common.ModelBinder(Common.BankAccount);
  }
  public deliveryNo: string = null;
  public get voucherNo() {
    return this.deliveryNo;
  }
  public salesPurchaseFlag:SalesPurchaseFlags = SalesPurchaseFlags.Purchase;
  public deliveryFlag: number = 0;
  public bookDate: Date = null;
  public scheduledDeliveryDate: Date = null;
  public deliveryDate: Date = null;
  public warehouseId: number = null;
  public warehouse: Common.Counterpart = null;
  public segmentId: number = 0;
  public segment: Common.Segment = null;
  public pic: string = '';
  public refNo: string = '';
  public counterpartId: number = 0;
  public counterpart: Common.Counterpart = null;
  public receiverId: number = null;
  public receiver: Common.Counterpart = null;
  public currencyCode: string = '';
  public exchangeRate: number = 1;
  public purchaseDeliveryNo: string = '';
  public isTransitPost:boolean = false;
  public purchaseInvoiceWorkflowId :number = 0;
 // 金額
public dealAmountFC: number = 0;
public amountFC: number = 0;
public taxAmountFC: number = 0;
public amount: number = 0;
public taxAmount: number = 0;
public totalAmount: number = 0;
public cashReceived: number = 0;
//案件
public projectItemNo : string = null;
public projectItem : Common.ProjectItem = null;
// 記載事項
public paymentTerm: string = '';
public description: string = '';
public remark: string = '';
public deliveryInstruction: string = '';

// 納入先詳細
public outputReceiverPostalCode: string = '';
public outputReceiverAddress1: string = '';
public outputReceiverAddress2: string = '';
public outputReceiverAddress3: string = '';
public outputReceiverName: string = '';
public outputReceiverPICSection: string = '';
public outputReceiverPIC: string = '';
public outputReceiverPICHonorificTitle: string = '';
public outputReceiverTelNo: string = '';
public outputReceiverFaxNo: string = '';
public forwarder: ForwarderFlags = ForwarderFlags.Default;
public arrivalDate: Date = null;
public arrivalHour: ForwarderTimezoneFlags = ForwarderTimezoneFlags.Default;
public shippingBoxes: number = 1;
public shippingDescription: string = '';
public shippingNo: string = '';

// 予備項目
public reserveText1: string = '';
public reserveText2: string = '';
public reserveText3: string = '';
public reserveText4: string = '';
public reserveText5: string = '';
public reserveText6: string = '';
public reserveMemo1: string = '';
public reserveMemo2: string = '';
public reserveMemo3: string = '';
public reserveDate1: Date = null;
public reserveDate2: Date = null;
public reserveDate3: Date = null;
public reserveList1: number = null;
public reserveList2: number = null;
public reserveList3: number = null;
public sourceDeliveryNo: string = null;  // 複製元入出荷番号

// 支払残高管理
public paymentBalanceId: number = null;
public paymentBalance: Common.TransferBalance = null;
public writeoffAmountFC: number = 0;
public pendingBalanceAmountFC:number = 0; //支払可能額

public closingDate: Date = null;
public dueDate: Date = null;
public settlement: Common.SettlementTypes = null;
public bankAccount: Common.BankAccount = null;

public pickingNo:string = null;
// 揮発性フィールド、明細選択時に設定される
public hasOrder: boolean = false;
  public designationReportTemplateId: number = null; // 指定帳票
// 引当削除をする場合設定される
public allocateDeleteFlag: boolean = false;
public importNo: string = null;
  public copy():any {
   if(this.deliveryFlag == Common.DeliveryFlags.Direct) throw new Error("直送伝票は複製できません。");
   if(this.isTransitPost) throw new Error("計上区分が未着品計上の伝票は複製できません。");
   const temp = super.copy() as Delivery;
   temp.sourceDeliveryNo = this.deliveryNo;
   temp.deliveryNo = '';
   temp.paymentBalance = null;
   temp.pickingNo = null;
   temp.importNo = null;
   temp.projectItem = null;
   temp.projectItemNo = null;
   return temp;
  }

  public onChangeCounterpart(){
    if(this.counterpart != null){
      this.reserveText1 = this.counterpart.reserveText1;
      this.reserveText2 = this.counterpart.reserveText2;
      this.reserveText3 = this.counterpart.reserveText3;
      this.reserveText4 = this.counterpart.reserveText4;
      this.reserveText5 = this.counterpart.reserveText5;
      this.reserveText6 = this.counterpart.reserveText6;
      this.reserveMemo1 = this.counterpart.reserveMemo1;
      this.reserveMemo2 = this.counterpart.reserveMemo2;
      this.reserveMemo3 = this.counterpart.reserveMemo3;
      this.reserveList1 = this.counterpart.reserveList1;
      this.reserveList2 = this.counterpart.reserveList2;
      this.reserveList3 = this.counterpart.reserveList3;
      this.paymentTerm = this.counterpart.paymentTerm;
      this.description = this.counterpart.description;
      this.remark = this.counterpart.remark;
    }
    else{
      this.reserveText1 = '';
      this.reserveText2 = '';
      this.reserveText3 = '';
      this.reserveText4 = '';
      this.reserveText5 = '';
      this.reserveText6 = '';
      this.reserveMemo1 = '';
      this.reserveMemo2 = '';
      this.reserveMemo3 = '';
      this.reserveList1 = null;
      this.reserveList2 = null;
      this.reserveList3 = null;
      this.paymentTerm = '';
      this.description = '';
      this.remark = '';
    }
  }

  public onChangeReceiver(){
    if(this.receiver != null){
      this.outputReceiverPostalCode = this.receiver.postalCode;
      this.outputReceiverAddress1 = this.receiver.address1;
      this.outputReceiverAddress2 = this.receiver.address2;
      this.outputReceiverAddress3 = this.receiver.address3;
      this.outputReceiverName = this.receiver.name;
      this.outputReceiverPICSection = this.receiver.picSection;
      this.outputReceiverPIC = this.receiver.pic;
      this.outputReceiverPICHonorificTitle = this.receiver.honorificTitle;
      this.outputReceiverTelNo = this.receiver.telNo;
      this.outputReceiverFaxNo = this.receiver.faxNo;
    }
    else{
      this.outputReceiverPostalCode = '';
      this.outputReceiverAddress1 = '';
      this.outputReceiverAddress2 = '';
      this.outputReceiverAddress3 = '';
      this.outputReceiverName = '';
      this.outputReceiverPICSection = '';
      this.outputReceiverPIC = '';
      this.outputReceiverPICHonorificTitle = '';
      this.outputReceiverTelNo = '';
      this.outputReceiverFaxNo = '';
    }
  }
  public onChangeWarehouse(){
    if(this.warehouse != null){
      this.outputReceiverPostalCode = this.warehouse.postalCode;
      this.outputReceiverAddress1 = this.warehouse.address1;
      this.outputReceiverAddress2 = this.warehouse.address2;
      this.outputReceiverAddress3 = this.warehouse.address3;
      this.outputReceiverName = this.warehouse.name;
      this.outputReceiverPICSection = this.warehouse.picSection;
      this.outputReceiverPIC = this.warehouse.pic;
      this.outputReceiverPICHonorificTitle = this.warehouse.honorificTitle;
      this.outputReceiverTelNo = this.warehouse.telNo;
      this.outputReceiverFaxNo = this.warehouse.faxNo;
    }
    else{
      this.outputReceiverPostalCode = '';
      this.outputReceiverAddress1 = '';
      this.outputReceiverAddress2 = '';
      this.outputReceiverAddress3 = '';
      this.outputReceiverName = '';
      this.outputReceiverPICSection = '';
      this.outputReceiverPIC = '';
      this.outputReceiverPICHonorificTitle = '';
      this.outputReceiverTelNo = '';
      this.outputReceiverFaxNo = '';
    }
  }    
  public get messageOnEdit():string { 
    switch(this.state){
      case DeliveryStatus.SalesDeliveryItemsOperateWaiting:return '「確定取消」をクリックして状態を「出荷確定待ち」に戻してから編集してください。';
      case DeliveryStatus.SalesDeliveryItemsOperating:
      case DeliveryStatus.SalesDeliveryCompleted: return '請求処理が行われているため編集できません。\r\n編集する場合は、先に【明細表示】より関連する明細をすべて請求取消してから、「確定取消」をクリックしてください。';
      case DeliveryStatus.PurchaseDeliveryCompleted : return '「確定取消」をクリックして状態を「入荷確定待ち」に戻してから編集してください。';
      default: return super.messageOnEdit;
    }
  }
  public get messageOnDelete():string {
      switch(this.state){
        case DeliveryStatus.SalesDeliveryItemsOperateWaiting:return '「確定取消」をクリックして状態を「出荷確定待ち」に戻してから削除してください。';
        case DeliveryStatus.SalesDeliveryItemsOperating:
        case DeliveryStatus.SalesDeliveryCompleted:return '請求処理が行われているため削除できません。\r\n削除する場合は、先に【明細表示】より関連する明細をすべて請求取消してから、「確定取消」をクリックしてください。';
        case DeliveryStatus.PurchaseDeliveryCompleted:return '「確定取消」をクリックして状態を「入荷確定待ち」に戻してから削除してください。';
        default: return super.messageOnDelete;
      }
  }
  public get messageOnActionMissing():string{
    if (this.salesPurchaseFlag == SalesPurchaseFlags.Sales) return '請求処理が行われているため、ワークフロー操作は行えません。';
    else return '';
  }  
}

export enum SalesPurchaseFlags
{
    Purchase = 0,
    Sales = 1,
}

export enum DeliveryStatus
{
  SalesDelivery = 1, // 出荷
  PurchaseDelivery = 2, // 入荷
  Instructions = 4, // 予定

  SalesDeliveryPostWaiting = SalesDelivery + 16, // 出荷確定待ち
  SalesDeliveryInspectionWaiting = SalesDelivery + 32, // 検品待ち
  SalesDeliveryItemsOperateWaiting = SalesDelivery + 64, // 請求処理待ち
  SalesDeliveryItemsOperating = SalesDelivery + 128, // 請求処理中
  SalesDeliveryCompleted = SalesDelivery + 256, // 完了
  SalesDeliveryNotCompleted = SalesDeliveryPostWaiting | SalesDeliveryItemsOperateWaiting | SalesDeliveryItemsOperating,
  
  PurchaseDeliverySaving = PurchaseDelivery + 16, // 入荷確定待ち
  PurchaseDeliveryInstruction =PurchaseDeliverySaving + Instructions,
  // PurchaseDeliveryPostWaitingPaymentWaiting =32, // 入荷確定待ち/支払処理開始待ち
  // PurchaseDeliveryPostWaitingPaying = 64, // 入荷確定待ち/支払処理中
  // PurchaseDeliveryPostWaiting =128, // 入荷確定待ち
  // PurchaseDeliveryPaymentWaiting =256, // 支払処理開始待ち
  // PurchaseDeliveryPaying =512, // 支払処理中
  // PurchaseDeliveryCompletedWithPayment =1024, // 完了(支払あり)
  // PurchaseDeliveryCompletedWithoutPayment =2048, // 完了(支払なし)
  PurchaseDeliveryInspectionWaiting = PurchaseDelivery + 32,
  PurchaseDeliveryCompleted = PurchaseDelivery + 64, //完了(新ステータス)//PurchaseDeliveryCompletedWithPayment | PurchaseDeliveryCompletedWithoutPayment,
  PurchaseDeliveryNotCompleted = PurchaseDeliverySaving | PurchaseDeliveryInspectionWaiting,
}

export enum DeliveryFlags {
  Stock = 0,
  Direct = 1,
  Services = 2,
  Commodity = 3,
}

export enum DeliveryVoucherTypes {
  Default = 0,
  Retrun = 1,
}

export enum ForwarderFlags
{
    //**未指定 */  
    Default = 0, 
    //**クロネコヤマト */
    Yamato = 1, 
    //**佐川急便 */    
    Sagawa = 2, 
    //**西濃運輸 */    
    Seinou = 3, 
}
export enum ForwarderTimezoneFlags
{   
    //**未指定 */
    Default = 0,
    //**午前中 */     
    Timezone0812 =  812,        
    //**午前(西濃のみ) */     
    Timezone0812s =  8122,        
    //**午後(西濃のみ) */     
    Timezone1220 = 1220,        
    //** 9～12時(西濃のみ) */     
    Timezone0912 =  912,        
    //**12～14時(佐川のみ) */         
    Timezone1214 = 1214,
    //**12～17時(西濃のみ) */     
    Timezone1217 = 1217,        
    //**14～16時(西濃以外) */          
    Timezone1416 = 1416,       
    //**16～18時(西濃以外) */          
    Timezone1618 = 1618,       
    //**17～20時(西濃のみ) */     
    Timezone1720 = 1720,        
    //**18～20時(西濃以外) */             
    Timezone1820 = 1820,      
    //**18～21時(佐川のみ) */         
    Timezone1821 = 1821,       
    //**19～21時(西濃以外) */         
    Timezone1921 = 1921,                 
}

export class SalesDelivery extends Delivery{
  constructor(){
    super()
    this.salesPurchaseFlag = SalesPurchaseFlags.Sales;
    this.workflowCode="salesDelivery";
    this.state = DeliveryStatus.SalesDeliveryPostWaiting;
    this.workflowStateId = DeliveryStatus.SalesDeliveryPostWaiting;
  }
  public get actionTooltip() {
    if (!this.deliveryNo) return '必須項目(★マーク)を入力して【追加する】をクリックします。';        
    else if (this.state == DeliveryStatus.SalesDeliveryPostWaiting)　return '明細の登録は、【出荷明細タブ】で【明細の追加】をクリックします。請求へ進む場合は【出荷確定】をクリックします。';
    else if (this.state == DeliveryStatus.SalesDeliveryInspectionWaiting) return '';
    else if (this.state == DeliveryStatus.SalesDeliveryItemsOperateWaiting) return '請求を行う場合は【請求処理】をクリックします。';      
    else if (this.state == DeliveryStatus.SalesDeliveryItemsOperating) return '請求を行う場合は【請求処理】をクリックします。';      
    else if (this.state == DeliveryStatus.SalesDeliveryCompleted) return '';                 
    else return '';
  }  
  public copy():any {
   const temp = super.copy() as SalesDelivery;
   temp.state = DeliveryStatus.SalesDeliveryPostWaiting;
   temp.workflowStateId = DeliveryStatus.SalesDeliveryPostWaiting;
   return temp;
  }
  public getTargetState(stateId : number, actionFlag : Common.DefaultActionFlags){
    //編集=>請求処理待ち
    if (actionFlag == Common.DefaultActionFlags.edit && stateId == DeliveryStatus.SalesDeliveryItemsOperateWaiting)
      return DeliveryStatus.SalesDeliveryPostWaiting;
    //削除=>請求処理待ち
    else if (actionFlag == Common.DefaultActionFlags.delete && stateId == DeliveryStatus.SalesDeliveryItemsOperateWaiting)
      return DeliveryStatus.SalesDeliveryPostWaiting;
    //更新=>出荷確定待ち
    else if (actionFlag == Common.DefaultActionFlags.update && stateId == DeliveryStatus.SalesDeliveryPostWaiting)
      return DeliveryStatus.SalesDeliveryItemsOperateWaiting;
    else
      return 0;
  }
}

export class DeliveryQuery extends Common.LoadQuery {
  constructor(salesPurchaseFlag: Common.SalesPurchaseFlags){
    super('DeliveryQuery', salesPurchaseFlag == Common.SalesPurchaseFlags.Purchase ? PurchaseDelivery : SalesDelivery);
    this.salesPurchaseFlag = salesPurchaseFlag;
    this.state = salesPurchaseFlag == Common.SalesPurchaseFlags.Purchase ?  Common.DeliveryStatus.PurchaseDeliveryNotCompleted : Common.DeliveryStatus.SalesDeliveryNotCompleted;
    this.sort = 'deliveryNo';
  }
  public get binder(): Common.ModelBinder {
    var binder = super.binder;
    binder.createInstance = ()=>new DeliveryQuery(this.salesPurchaseFlag);    
    return binder;
  }  
  public salesPurchaseFlag: Common.SalesPurchaseFlags = Common.SalesPurchaseFlags.Sales;
  public counterpartClosingDate: Common.DateTypes;
  public segment: Common.Segment = null;
  public counterpart: Common.Counterpart = null;
  public warehouse: Common.Counterpart = null;
  public projectItem: Common.ProjectItem = null;  
  public projectItemNo: string = null;
  public pic: string = '';
  public deliveryNo: string = '';
  public receiverName: string = '';
  public orderNo: string = '';
  public refNo: string ='';
  public description: string = '';
  public currencyCode: string = '';  
  // public scheduledDeliveryDateFrom: Date = null;
  // public scheduledDeliveryDateTo: Date = null;
  public deliveryDateFrom: Date = null;
  public deliveryDateTo: Date = null;
  public bookDateFrom: Date = null;
  public bookDateTo: Date = null;  
  public dealAmountFcFrom: number = null;
  public dealAmountFcTo: number = null;
  public initialSavedOnFrom: Date = null;
  public initialSavedOnTo: Date = null;
  public lastUpdatedOnFrom: Date = null;
  public lastUpdatedOnTo: Date = null;
  public state: Common.DeliveryStatus = Common.DeliveryStatus.SalesDeliveryNotCompleted;
  public holder: string = '';
  public isTransitPost:boolean = null;
  public pickingNo : string = null;
  // 取引先区分
  public category1: number = null;
  public category2: number = null;
  public category3: number = null;
  public category4: number = null;
  public category5: number = null;
  public category6: number = null;

  //日付フラグ
  public deliveryDateFromFlag: Common.dateFlags = Common.dateFlags.default;
  public deliveryDateToFlag : Common.dateFlags = Common.dateFlags.default;  
  public bookDateFromFlag: Common.dateFlags = Common.dateFlags.default;
  public bookDateToFlag : Common.dateFlags = Common.dateFlags.default;    

    // 予備項目
  public reserveText1: string = '';
  public reserveText2: string = '';
  public reserveText3: string = '';
  public reserveText4: string = '';
  public reserveText5: string = '';
  public reserveText6: string = '';
  public reserveMemo1: string = '';
  public reserveMemo2: string = '';
  public reserveMemo3: string = '';
  public reserveDate1From: Date = null;
  public reserveDate1To: Date = null;
  public reserveDate2From: Date = null;
  public reserveDate2To: Date = null;
  public reserveDate3From: Date = null;
  public reserveDate3To: Date = null;
  public reserveList1: number = null;
  public reserveList2: number = null;
  public reserveList3: number = null;
}

export class DeliveryImportQuery extends Common.ImportQuery {
  constructor(sheetName:string, salesPurchaseFlag:number){
    super("",null);
    this.className = "DeliveryImportQuery";
    this.sheetName = sheetName;
    this.salesPurchaseFlag = salesPurchaseFlag;
  }
  public sheetName  :string;
  public salesPurchaseFlag : number;
  public hasLicenseCurrency: boolean = false;
}
export class DeliveryExportQuery extends Common.ExportQuery {
  constructor(sheetName:string, loadQuery:Common.LoadQuery, salesPurchaseFlag:number){
    super("",loadQuery);
    this.className = "DeliveryExportQuery";
    this.loadQuery = loadQuery;
    this.sheetName = sheetName;
    this.salesPurchaseFlag = salesPurchaseFlag;
  }
  public loadQuery : Common.LoadQuery;
  public sheetName  :string;
  public salesPurchaseFlag : number;
  public hasLicenseCurrency: boolean = false;
}

export class PurchaseDelivery extends Delivery{
  constructor(){
    super()
    this.salesPurchaseFlag = SalesPurchaseFlags.Purchase;
    this.workflowCode="purchaseDelivery";
    this.state = DeliveryStatus.PurchaseDeliverySaving;
    this.workflowStateId = DeliveryStatus.PurchaseDeliverySaving;
    this.settlement = Common.SettlementTypes.ByPayable;
    this.deliveryDate = new Date().getCalendarDate();
  }
  public get actionTooltip() {
    if (!this.deliveryNo) return '必須項目(★マーク)を入力して【追加する】をクリックします。';        
    else if (this.state == DeliveryStatus.PurchaseDeliverySaving)　return '明細の登録は、【入荷明細タブ】で【明細の追加】をクリックします。仕入計上へ進む場合は【入荷確定】をクリックします。';
    else if (this.state == DeliveryStatus.PurchaseDeliveryInspectionWaiting) return '';
    else if (this.state == DeliveryStatus.PurchaseDeliveryCompleted) return '入荷を訂正する場合は【確定取消】をクリックします。';                 
    else return '';
  }    
  public copy():any {
   const temp = super.copy() as PurchaseDelivery;
   temp.state = DeliveryStatus.PurchaseDeliverySaving;
   temp.workflowStateId = DeliveryStatus.PurchaseDeliverySaving;
   return temp;
  }
  public getTargetState(stateId : number, actionFlag : Common.DefaultActionFlags){
    //編集=>完了
    if (actionFlag == Common.DefaultActionFlags.edit && stateId == DeliveryStatus.PurchaseDeliveryCompleted)
      return DeliveryStatus.PurchaseDeliverySaving;
    //削除=>完了
    else if (actionFlag == Common.DefaultActionFlags.delete && stateId == DeliveryStatus.PurchaseDeliveryCompleted)
      return DeliveryStatus.PurchaseDeliverySaving;
    //更新=>入荷確定待ち
    else if (actionFlag == Common.DefaultActionFlags.update && stateId == DeliveryStatus.PurchaseDeliverySaving)
      return DeliveryStatus.PurchaseDeliveryCompleted;
    else
      return 0;
  }     
}

export class BundleAddDeliveryItemQuery extends Common.Query {
  constructor(salesPurchaseFlag:number){
      if(salesPurchaseFlag == Common.SalesPurchaseFlags.Sales)
        super('BundleAddDeliveryItemQuery',new Common.ModelBinder(SalesDelivery,false));
      else
        super('BundleAddDeliveryItemQuery',new Common.ModelBinder(PurchaseDelivery,false));
    }
    public deliveryItems: Array<Common.DeliveryItem>;
}

export class AdvancePaymentJouralQuery extends Common.LoadQuery {
  constructor(){
        super('AdvancePaymentJouralQuery',Delivery);
    }
    public delivery: Delivery;
} 

export class AdvancePaymentWriteoffAddQuery extends Common.Query {
  constructor(){
        super('AdvancePaymentWriteoffAddQuery',new Common.ModelBinder(Delivery,false));
    }
    public delivery: Delivery;
    public orders: Array<Common.Order>;
} 

export class AdvancePaymentWriteoffDeleteQuery extends Common.Query {
  constructor(){
        super('AdvancePaymentWriteoffDeleteQuery',new Common.ModelBinder(Delivery,false));
    }
    public transferJournal: Common.TransferJournal;
} 

export class DeliveryPaymentQuery extends Common.Query {
  constructor(){
    super('DeliveryPaymentQuery',new Common.ModelBinder(Delivery,false));
  }
  public segment: Common.Segment = null;
  public pic: string = "";
  public counterpart: Common.Counterpart;
  public currencyCode: string;
  public paymentDate: Date;
  public bankAccount: Common.BankAccount = null;
  public exchangeRate: number = 0;
  public commissionAmountFC: number = 0;
  public settlementAmountFC: number = 0;
  public commissionTaxFlag: boolean = false;
  public deliveries: Array<Common.Delivery>;
} 

export class GetDeliveryItemQuery extends Common.Query{
  constructor(){
    super('GetDeliveryItemQuery', new Common.ModelBinder(GetDeliveryItemResult, false));
  }
  public deliveryNo: string = '';
}
export class GetDeliveryItemResult  extends Common.ObjectBase{
    constructor(){
        super('');
    }
  public hasItem: boolean;
  public hasOrder: boolean;
}
export class GetDeliveriesCounterpart extends Common.Query{
  constructor(){
    super('GetDeliveriesCounterpart', new Common.ModelBinder(Common.Counterpart, true));
  }
  public deliveries: Array<Common.Delivery> = new Array(0);
}